import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const PublicHeader = () => {
  const navigate = useNavigate();
  return (
    <header className="absolute top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm border-b border-stone-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="font-serif text-xl text-stone-900">
            {process.env.REACT_APP_NAME || 'Lenscribe'}
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-sm text-stone-500 hover:text-stone-900 transition-colors">
              Features
            </a>
            <a href="#pricing" className="text-sm text-stone-500 hover:text-stone-900 transition-colors">
              Pricing
            </a>
            <a href="#faq" className="text-sm text-stone-500 hover:text-stone-900 transition-colors">
              FAQ
            </a>
          </nav>

          <button
            onClick={() => navigate('/login')}
            className="bg-stone-900 text-white px-4 py-2 rounded text-sm font-medium hover:bg-stone-800 transition-colors"
          >
            Get Started
          </button>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
